import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './AuthService';
import { UsersService } from '../app/api/api/users.service';
import { TokensService } from '../app/api/api/tokens.service';
import { of, catchError, map } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const usersApi = inject(UsersService);
  const tokensApi = inject(TokensService);

  if (!auth.isLoggedIn()) {
    return router.parseUrl('/login');
  }

  // Double check session with Registry API
  return tokensApi.apiTokenValidateGet().pipe(
    map(() => true),
    catchError(() => {
      auth.logout();
      return of(router.parseUrl('/login'));
    })
  );
};
